import { iconForActionType } from './actionTypeIcons'

interface Props {
  code: string
  label: string
  className?: string
}

/** Read-only chip pokazujący typ akcji taska. Ikona z lucide-react (Phone/Users/Mail/MapPin/...)
 *  + label snapshot. Klikalność dodaje konsument (np. KanbanCard jest klikalna w całości). */
export function ActionTypeChip({ code, label, className }: Props) {
  const Icon = iconForActionType(code)
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded bg-slate-100 px-1.5 py-0.5 text-xs text-slate-700 ${className ?? ''}`}
      title={label}
    >
      <Icon className="size-3 flex-shrink-0" />
      <span>{label}</span>
    </span>
  )
}
